/**
 * 파일명: privacyConsentDoc.js
 * 작성자: 김준형
 * 작성일자: 26.08.13
 * 설명: About Us - Contact Us 문의 폼의 개인정보 수집 및 이용 동의 전문
 */
const PRIVACY_CONSENT = {
  title: "개인정보 수집 및 이용 동의",
  blocks: [
    {
      type: "text",
      text: "(주)리브테크놀로지(이하 “회사”)는 홈페이지 문의 접수 및 답변을 위하여 아래와 같이 개인정보를 수집·이용합니다. 내용을 확인하신 후 동의 여부를 결정해 주세요.",
    },

    { type: "heading", text: "1. 수집하는 개인정보 항목" },
    { type: "sub", text: "[필수] 문의하기 작성 시 입력하는 정보" },
    {
      type: "list",
      items: ["성함", "소속(회사)", "연락처", "이메일 주소"],
    },
    { type: "sub", text: "[선택] 문의내용에 이용자가 직접 기재하는 정보" },
    {
      type: "text",
      text: "홈페이지 이용 과정에서 자동으로 생성·수집되는 접속 기록, 쿠키 등에 관한 사항은 개인정보처리방침에서 확인하실 수 있습니다.",
    },

    { type: "heading", text: "2. 개인정보의 수집 및 이용 목적" },
    {
      type: "list",
      items: [
        "문의 내용 확인 및 문의하신 분의 식별",
        "문의에 대한 답변 및 상담 진행(전화·이메일 회신)",
        "솔루션·제품 도입 상담 및 관련 자료 제공",
        "문의 처리 이력 관리 및 응대 품질 개선",
      ],
    },

    { type: "heading", text: "3. 개인정보의 보유 및 이용 기간" },
    {
      type: "text",
      text: "문의 처리가 완료된 날부터 3년간 보유·이용하며, 그 이후에는 지체 없이 파기합니다. 다만 관계 법령에 따라 보존 의무가 있는 경우에는 해당 기간까지 보관합니다.",
    },
    {
      type: "list",
      items: [
        "소비자의 불만 또는 분쟁처리에 관한 기록 : 3년 (「전자상거래 등에서의 소비자보호에 관한 법률」)",
        "표시·광고에 관한 기록 : 6개월 (「전자상거래 등에서의 소비자보호에 관한 법률」)",
      ],
    },

    { type: "heading", text: "4. 동의를 거부할 권리 및 거부 시 불이익" },
    {
      type: "text",
      text: "귀하는 개인정보 수집·이용에 대한 동의를 거부할 권리가 있습니다. 다만 위 항목은 문의 접수 및 답변에 반드시 필요한 최소한의 정보이므로, 동의를 거부하시는 경우 문의하기 이용이 제한됩니다.",
    },

    { type: "heading", text: "5. 그 밖의 사항" },
    {
      type: "text",
      text: "개인정보의 제3자 제공, 파기 절차, 정보주체의 권리 행사 방법 등 개인정보 처리에 관한 자세한 내용은 개인정보처리방침에서 확인하실 수 있습니다.",
    },
  ],
};

export default PRIVACY_CONSENT;
